import React from "react";

import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormLabel from "@material-ui/core/FormLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import { Link } from '@material-ui/core'

// based on https://github.com/rjsf-team/react-jsonschema-form/blob/master/packages/material-ui/src/RadioWidget/RadioWidget.tsx

const RadioWidget = ({
  id,
  schema,
  options,
  value,
  disabled,
  readonly,
  label,
  onChange,
  onBlur,
  onFocus,
}) => {
  const { enumOptions, enumDisabled } = options;

  const _onChange = (_, value) => {
    onChange(schema.type === "boolean" ? value !== "false" : value)
  };
  const _onBlur = ({ target: { value } }) =>
    onBlur(id, value);
  const _onFocus = ({
    target: { value },
  }) => onFocus(id, value);

  const row = options ? options.inline : false;

  return (
    <>
      <FormLabel required={false} htmlFor={id} style={{ marginBottom: '1em' }}>
        {label || schema.title}
      </FormLabel>
      <RadioGroup
        value={`${value}`}
        row={row}
        onChange={_onChange}
        onBlur={_onBlur}
        onFocus={_onFocus}>
        {(enumOptions).map((option, i) => {
          const itemDisabled = enumDisabled && (enumDisabled).indexOf(option.value) !== -1;

          const radio = (
            <FormControlLabel
              control={<Radio color="primary" key={i}/>}
              label={<div>Souhlasím se <Link href='/consent' target='_blank'>zpracováním
                osobních údajů</Link></div>}
              value={`${option.value}`}
              key={i}
              disabled={disabled || itemDisabled || readonly}
            />
          );

          return radio;
        })}
      </RadioGroup>
    </>
  );
};

export default RadioWidget;
